const one = require("./images/1.JPG");
const two = require("./images/2.JPG");
const three = require("./images/3.JPG");
const app1 = require("./images/app_1.PNG");
const app3 = require("./images/app_2.PNG");
const app2 = require("./images/app_3.PNG");

const Steps = () => {
  return (
    <section className="py-14 main">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <figure>
            <div className="text-center">
              <h2 className="text-gray-800 text-4xl font-extrabold my-2">
                Get started in a few simple steps
              </h2>
              <p className="bg-gray-50">
                Don't waste time searching on the Internet - spend time on your
                favorite things.
              </p>
            </div>
            {/* <div className="flex text-center items-center gap-x-4 mt-6">
                          <img src={one} className="w-16 h-16 rounded-full" alt=""/>
                          <div className="text-left">
                              <span className="block text-gray-800 font-bold text-lg">Create an account</span>
                              <p className="text-yellow-600 font-semibold">Register in seconds and start using all features of our platform</p>
                          </div>
                      </div>

                      <div className="flex items-center gap-x-4 mt-6">
                          <img src={two} className="w-16 h-16 rounded-full" alt=""/>
                          <div className="text-left">
                              <span className="block text-gray-800 font-bold text-lg">Leave your request</span>
                              <p className="text-yellow-600 font-semibold">We manage each request and you will be always updated</p>
                          </div>
                      </div>

                      <div className="flex items-center gap-x-4 mt-6">
                          <img src={three} className="w-16 h-16 rounded-full" alt=""/>
                          <div className="text-left">
                              <span className="block text-gray-800 font-bold text-lg">Get affordable and reasonable offer</span>
                              <p className="text-yellow-600 font-semibold">Find available handyman near you in 12-24 hours</p>
                          </div>
                      </div> */}
          </figure>
        </div>
        <div className="flex md:flex-row justify-center max-w-6xl flex-col mx-auto gap-4 mt-20 bg-sky-700 p-7 rounded-lg">
          <div className="my-3 items-center text-center flex flex-col gap-4">
            <h2 className="text-gray-100 text-3xl font-bold md:text-3xl">
              Fast registration
            </h2>
            <p className="text-gray-300 max-w-sm mx-auto">
              Just enter your active email address and go ahead
            </p>
            <img
              fetchpriority="low"
              src={app1}
              className="rounded-lg h-[300px] w-[170px] border shadow-2xl"
              alt=""
            />
          </div>
          <div className="my-3 items-center text-center flex flex-col gap-4">
            <h2 className="text-gray-100 text-3xl font-bold md:text-3xl">
              Leave your request
            </h2>
            <p className="text-gray-300">
              Handymans will recieve your requests imidiatly
            </p>
            <img
              fetchpriority="low"
              src={app2}
              className="rounded-lg h-[300px] w-[170px] border shadow-2xl"
              alt=""
            />
          </div>
          <div className="my-3 items-center text-center flex flex-col gap-4">
            <h2 className="text-gray-100 text-3xl font-bold md:text-3xl">
              Get responses
            </h2>
            <p className="text-gray-300">
              Find available handyman near you in 12-24 hours
            </p>
            <img
              fetchpriority="low"
              src={app3}
              className="rounded-lg h-[300px] w-[170px] border shadow-2xl"
              alt=""
            />
          </div>
        </div>
        <div className="text-center">
          <p className="mt-8 text-4xl text-center font-extrabold">
            Simple easy, isn't it?
          </p>
          <a href="/">
            <button className="mt-6 py-2 px-8 text-center text-white font-medium bg-sky-600 duration-150 hover:bg-sky-500 active:bg-sky-700 rounded-lg shadow-lg hover:shadow-none">
              Sign Up Now
            </button>
          </a>
          <a href="#appointment">
          <button className="mt-6 py-2 md:ml-2 px-8 text-center text-white font-medium bg-orange-600 duration-150 hover:bg-sky-500 active:bg-sky-700 rounded-lg shadow-lg hover:shadow-none">
            Leave Request Without Registration
          </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Steps;
